import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="preorder-hide"
export default class extends Controller {
  static targets = ["selector", "preorderFields"];

  connect() {
    console.log("PreorderHideController connected");
  }

  onChange() {
    const value = this.selectorTarget.value
    console.log("Selected product_type:", value)

    if (value === "preorder") {
      this.preorderFieldsTarget.classList.remove("hidden")
    } else if (value === "stocked") {
      this.preorderFieldsTarget.classList.add("hidden")
    }
  }
}
